import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
// hooks
import { useLocation } from 'react-router-dom';
import { Player } from '@lottiefiles/react-lottie-player';
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
// sections
import { LoginForm } from '../sections/auth/login';
import ResetForm from '../sections/auth/login/ResetForm';
import UpdateForm from '../sections/auth/login/UpdateForm';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const reset = query.get('reset');
  const token = query.get('token');

  return (
    <>
      <Helmet>
        <title> Connexion | Espace Pokou La:Matrice </title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Player
              src='https://assets9.lottiefiles.com/private_files/lf30_1TcivY.json'
              className="player"
              loop
              autoplay
            />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
              {reset && <ResetForm />}
              {token && <UpdateForm />}
              {!reset && !token && <LoginForm />}
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
